const logError = (op: string, error: unknown) => {
  console.error(`Error while performing local storage operation: ${op}`, error);
};

const lsLog = {
  error: logError,
};

export default lsLog;
